import SentNotificationTable from './SentNotificationTable';

export default SentNotificationTable;
